import React from 'react';
import { BrowseContactLink } from '../browse/BrowseContactLink';

export default function CompanyListRows({ rows }) {
  return rows.map((c) => {
    const name = c.name || '—';
    const affiliation = c.affiliation_name ? String(c.affiliation_name).trim() : '';
    const city = c.city ? String(c.city).trim() : '';

    return (
      <article key={c.id} className="recv-browse-row recv-browse-row--company" role="listitem">
        <div className="recv-browse-list__cell recv-browse-list__cell--lead">
          <div className="recv-browse-row__identity">
            <div className="recv-browse-row__title" title={name}>
              {name}
            </div>
            <div className="recv-browse-row__meta-line">
              {city ? <span>{city}</span> : null}
              {c.company_code ? (
                <span className="font-monospace">{c.company_code}</span>
              ) : affiliation ? (
                <span>{affiliation}</span>
              ) : null}
              {!city && !c.company_code && !affiliation ? (
                <span className="recv-browse-row__meta-line--muted">—</span>
              ) : null}
            </div>
          </div>
        </div>
        <div className="recv-browse-list__cell recv-browse-list__cell--contact">
          <span className="recv-browse-row__label">Contact</span>
          <div className="recv-browse-row__contact-stack">
            <BrowseContactLink kind="phone" value={c.phone} />
            <BrowseContactLink kind="mail" value={c.mail} />
          </div>
        </div>
      </article>
    );
  });
}
